import { FC } from 'react'
import { Button, ButtonProps, Icon } from '@/ui'
import { regular } from '@fortawesome/fontawesome-svg-core/import.macro'

const UploadBackButton: FC<ButtonProps> = (props) => (
  <Button {...props} variant="link">
    <Icon icon={regular('arrow-left')} className="mt-[-0.5rem]" />
    Back
  </Button>
)

export { UploadBackButton }
